import React from 'react';
import { handle400Statuses, sendApiRequest } from '@services/api';
import { logNetRequest } from '@utils/usefulFuncs';

const getSearchResultsFromAPI = async (v, isResearchMode, onlyCompanyTags) => {
  let URL = `v1/genai_tickers_search?query=${v}`;
  if (isResearchMode) {
    URL += '&research_only=true';
  }
  if (onlyCompanyTags) {
    URL += '&company_tags_only=true';
  }
  const { status, data, error } = await sendApiRequest('get', URL);
  handle400Statuses(status);
  logNetRequest(URL, status, data);
  return {
    status,
    data,
    error,
  };
};

export const useTagSearchResults = (inputValue, options) => {
  const isResearchMode = options.isResearchMode || false;
  const showCompanyTags = options.showCompanyTags || false;
  const onlyCompanyTags = options.onlyCompanyTags || false;

  const [selectableTags, setSelectableTags] = React.useState([]);
  const [activeQuery, setActiveQuery] = React.useState([]);
  const [isQuerying, setIsQuerying] = React.useState(false);

  React.useEffect(() => {
    const queryRequestStatus = { isCanceled: false };
    const handleInputChange = async (inputValue, queryRequestStatus) => {
      if (queryRequestStatus.isCanceled) return null;

      if (inputValue !== '') {
        setIsQuerying(true);
        const { status, data } = await getSearchResultsFromAPI(inputValue, isResearchMode, onlyCompanyTags);
        if (status === 200) {
          if (!queryRequestStatus.isCanceled) {
            let filteredResults = showCompanyTags ? data : filterStocksOnly(data);
            if (onlyCompanyTags) {
              filteredResults = filteredResults.filter((r) => r.doc_tag_id !== null);
            }
            setSelectableTags(filteredResults.slice(0, 30));
            setActiveQuery(inputValue);
            setIsQuerying(false);
          }
        } else {
          setTimeout(() => {
            setIsQuerying(false);
            handleInputChange(inputValue, queryRequestStatus);
          }, 500);
        }
      }
    };
    if (inputValue === '') {
      setSelectableTags([]);
      setActiveQuery('');
    } else {
      handleInputChange(inputValue, queryRequestStatus);
    }

    return () => {
      queryRequestStatus.isCanceled = true;
    };
  }, [inputValue]);

  return [isQuerying, selectableTags, activeQuery];
};

function filterStocksOnly(data) {
  // const { company_id, doc_tag_id, name, symbol } = result;
  return data.filter((r) => r.doc_tag_id === null);
}

export const useStockSearch = (inputValue, showCompanyTags) => {
  const [isLoading, setIsLoading] = React.useState(false);
  const [error, setError] = React.useState(null);
  const [results, setResults] = React.useState(null);

  React.useEffect(() => {
    const queryRequestStatus = { isCanceled: false };
    const handleInputChange = async (inputValue, queryRequestStatus) => {
      if (queryRequestStatus.isCanceled) return null;

      if (inputValue !== '') {
        setIsLoading(true);
        const { status, data } = await getSearchResultsFromAPI(inputValue);
        setIsLoading(false);
        if (status === 200) {
          if (!queryRequestStatus.isCanceled) {
            const filteredResults = showCompanyTags ? data : filterStocksOnly(data);
            setResults(filteredResults.slice(0, 30));
          }
        } else {
          setTimeout(() => {
            handleInputChange(inputValue, queryRequestStatus);
          }, 500);
        }
      }
    };
    if (inputValue === '') {
      setResults([]);
    } else {
      handleInputChange(inputValue, queryRequestStatus);
    }

    return () => {
      queryRequestStatus.isCanceled = true;
    };
  }, [inputValue]);

  return {
    isLoading,
    error,
    results,
  };
};
